module.exports = __webpack_public_path__ + "img/FR12506.d3bdebef.png";